<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <div class="row">
              <select-component
                modelName="farm_ids"
                :rowClass="
                  dataFilter.by_sel === 'year'
                    ? `col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3`
                    : `col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3`
                "
                :isMultiple="true"
                :dataOptions="farms"
                :requireClass="`required-farm`"
                :labelSelect="`${$t('common_words.farms2')}: *`"
                :initialSelection="dataFilter.farm_ids"
                @onChange="handleChangeSelected"
              />
              <select-component
                modelName="by_sel"
                :rowClass="
                  dataFilter.by_sel === 'year'
                    ? `col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2`
                    : `col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2`
                "
                :isMultiple="false"
                :dataOptions="bySelOptions"
                :requireClass="`required-bySel`"
                :labelSelect="`${$t('common_words.analyze_by')} *`"
                :initialSelection="dataFilter.by_sel"
                @onChange="handleChangeSelected"
              />
              <div
                :class="
                  dataFilter.by_sel === 'year'
                    ? `col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2`
                    : `col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2`
                "
                v-if="dataFilter.by_sel"
              >
                <label>{{ $t('common_words.year') }}: *</label>
                <br />
                <el-date-picker
                  name="year"
                  type="year"
                  class="shadow-sm required-year"
                  v-model="dataFilter.year_sel"
                  value-format="yyyy"
                  :placeholder="`${$t('common_words.select2')}...`"
                  @change="handleChangeYear"
                />
              </div>
              <template v-if="dataFilter.by_sel === 'week'">
                <select-component
                  modelName="init_week"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2`"
                  :isMultiple="false"
                  :dataOptions="optionWeeks"
                  :requireClass="`required-initWeek`"
                  :labelSelect="`${$t('common_words.initial_week')} *`"
                  :initialSelection="dataFilter.init_week"
                  :disabled="!dataFilter.year_sel"
                  @onChange="handleChangeSelected"
                />
                <select-component
                  modelName="end_week"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2`"
                  :isMultiple="false"
                  :dataOptions="optionsEndWeek"
                  :requireClass="`required-endWeek`"
                  :labelSelect="`${$t('common_words.end_week2')} *`"
                  :initialSelection="dataFilter.end_week"
                  :disabled="!dataFilter.year_sel"
                  @onChange="handleChangeSelected"
                />
              </template>
              <select-component
                modelName="activity_ids"
                :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                :isMultiple="true"
                :dataOptions="cpaActivities"
                :labelSelect="`${$t('common_words.activities')}:`"
                :initialSelection="dataFilter.activity_ids"
                :disabled="!canLoadCpaActivities"
                @onChange="handleChangeSelected"
              />
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="handleFilter"
                >
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>

    <!-- GRAFICAS -->
    <div class="col-12" v-if="hasData">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6">
          <card>
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions[0]"></highcharts>
              </div>
            </div>
          </card>
        </div>

        <div class="col-12 col-md-12 col-lg-6">
          <card>
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions[1]"></highcharts>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>

    <div class="col-12" v-if="hasData">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6">
          <card>
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions[2]"></highcharts>
              </div>
            </div>
          </card>
        </div>

        <div class="col-12 col-md-12 col-lg-6">
          <card>
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions[3]"></highcharts>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="tableData.length > 0">
      <card>
        <card-header
          :propPagination="pagination"
          @searchedQuery="handleSearchQuery"
          class="mr-3 mt-4"
        />
        <div class="legend-container">
          <div class="legend-item">
            <strong>P</strong>: {{ $t('labor.scheduled') }}
          </div>
          <div class="legend-item">
            <strong>E</strong>: {{ $t('labor.executed') }}
          </div>
          <div class="legend-item">
            <strong>%</strong>: {{ $t('common_words.compliance') }}
          </div>
        </div>
        <el-collapse v-model="activeFarmTables">
          <el-collapse-item
            v-for="farmGroup in queriedFarmGroups"
            :key="farmGroup.farm_id || farmGroup.farm_name"
            :name="farmGroup.farm_name"
          >
            <template slot="title">
              <strong>{{ farmGroup.farm_name }}</strong>
            </template>
            <el-table
              :ref="`activityCompletionTable-${farmGroup.farm_id}`"
              style="width: 100%"
              :data="farmGroup.rows"
              :default-sort="{ prop: 'activity', order: 'ascending' }"
              :cell-style="handleCellStyle"
            >
              <el-table-column type="expand" min-width="50" :fixed="true">
                <template slot-scope="props">
                  <div class="expand-content">
                    <table>
                      <tbody>
                        <tr
                          v-for="(detailedLot, lot) in props.row.detailed_lots"
                          :key="lot"
                        >
                          <td style="width: 50px; border: none !important"></td>
                          <td
                            style="width: 250px; border: none !important"
                          ></td>
                          <td
                            style="
                              width: 140px;
                              font-weight: bold;
                              text-align: left;
                            "
                          >
                            {{ lot }}
                          </td>
                          <template v-for="week in weeks">
                            <td :key="`${lot}-${week}-P`" style="width: 60px">
                              {{
                                getWeekData(
                                  week,
                                  detailedLot,
                                  'planned_quantity'
                                )
                              }}
                            </td>
                            <td :key="`${lot}-${week}-E`" style="width: 60px">
                              {{
                                getWeekData(
                                  week,
                                  detailedLot,
                                  'executed_quantity'
                                )
                              }}
                            </td>
                            <td
                              :key="`${lot}-${week}-%`"
                              style="width: 80px"
                              :class="getCompletionRateClass(week, detailedLot)"
                            >
                              {{
                                getWeekData(
                                  week,
                                  detailedLot,
                                  'completion_rate_formatted'
                                )
                              }}
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </el-table-column>

              <template v-for="column in tableColumns">
                <el-table-column
                  v-if="!column.children"
                  :key="`col-${column.label}`"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.minWidth"
                  :align="column.align"
                  :sortable="column.sortable"
                  :fixed="column.fixed"
                  :formatter="getFormatter(column.formatter)"
                />
                <el-table-column
                  v-else
                  :key="`group-${column.label}`"
                  :label="column.label"
                  align="center"
                >
                  <el-table-column
                    v-for="subColumn in column.children"
                    :key="subColumn.prop"
                    :prop="subColumn.prop"
                    :label="subColumn.label"
                    :min-width="subColumn.minWidth"
                    :align="subColumn.align"
                  />
                </el-table-column>
              </template>
            </el-table>
          </el-collapse-item>
        </el-collapse>
        <card-footer :propPagination="pagination" ref="cardfooter" />

        <export-tables
          :pdf="{
            filename: '',
            route: '',
            showPDFButton: false,
          }"
          :xls="{
            filename: `${$t('grow.activity_completion')}_${
              dataFilter.year_sel
            }.xlsx`,
            route: 'grow/activitycompletion/excel',
            paramMethod: 'POST',
            plusData: { ...getDataToExport },
          }"
        />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import drilldown from 'highcharts/modules/drilldown';
import exportingInit from 'highcharts/modules/exporting';
import Formatter from 'src/class/Formatter';
import Filter from 'src/components/Filter/Filters.vue';
import configTable from './activity-completion-table';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import mixinDatePicker from 'src/util/mixinDatePicker';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinNotification } from 'src/mixins/mixin-notification';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';

drilldown(Highcharts);
exportingInit(Highcharts);

export default {
  name: 'ActivityCompletion',

  components: {
    [Filter.name]: Filter,
    highcharts: Chart,
  },

  data() {
    return {
      dataFilter: {
        by_sel: 'year',
        end_week: null,
        farm_ids: [],
        init_week: null,
        year_sel: moment().format('YYYY'),
        activity_ids: [],
      },

      activeName: 'filter',
      valueCollapse: null,

      farms: [],
      cpaActivities: [],
      tableData: [],
      flatTableData: [],
      tableColumns: [],
      weeks: [],
      activeFarmTables: [],
      searchQuery: '',
      fuseSearch: null,
      pagination: {},
      optionsEndWeek: [],

      // [0]=Time, [1]=Farm, [2]=Activity, [3]=Supervisor
      chartOptions: [{}, {}, {}, {}],
      rawChart: null,

      hasData: false,
    };
  },

  computed: {
    ...configTable().Search,

    queriedData() {
      let result = this.flatTableData;

      if (this.searchQuery !== '') {
        result = this.fuseSearch
          ? this.fuseSearch.search(`=${this.searchQuery}`)
          : [];
      }

      this.pagination.total = result.length;

      if (this.$refs.cardfooter) {
        this.$refs.cardfooter.totals = this.pagination.total;
      }

      return result.slice(this.from, this.to);
    },

    queriedFarmGroups() {
      return this.tableData
        .map((farmGroup) => ({
          ...farmGroup,
          rows: this.queriedData.filter(
            (row) =>
              `${row.farm_id}` === `${farmGroup.farm_id}` ||
              row.farm_name === farmGroup.farm_name
          ),
        }))
        .filter((farmGroup) => farmGroup.rows.length > 0);
    },

    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    bySelOptions() {
      return [
        { id: 'year', name: i18n.t('common_words.year') },
        { id: 'week', name: i18n.t('common_words.week') },
      ];
    },

    canLoadCpaActivities() {
      return (
        Array.isArray(this.dataFilter.farm_ids) &&
        this.dataFilter.farm_ids.length > 0 &&
        this.dataFilter.year_sel
      );
    },

    getDataToExport() {
      const response = {
        data: this.tableData,
        year_sel: this.dataFilter.year_sel,
      };
      delete response.route;

      return response;
    },
  },

  mixins: [
    mixinDatePicker,
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinValidations,
    MixinCharts,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleChangeYear(year) {
      this.optionWeeks = this.generateWeekList(year).map((week) => ({
        id: week,
        name: week,
      }));
      this.dataFilter.init_week = null;
      this.dataFilter.end_week = null;
      this.loadCpaActivities();
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleSearchQuery(query) {
      this.searchQuery = query;
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      this.$set(this.chartOptions, 0, {});
      this.$set(this.chartOptions, 1, {});
      this.$set(this.chartOptions, 2, {});
      this.$set(this.chartOptions, 3, {});
      this.hasData = false;

      if (data.name === 'init_week') {
        this.dataFilter.end_week = null;

        const selectedIndex = this.optionWeeks.findIndex(
          (week) => week.id === data.selects
        );

        if (selectedIndex !== -1) {
          this.optionsEndWeek = this.optionWeeks.slice(selectedIndex);
        } else {
          this.optionsEndWeek = [];
        }
      } else if (data.name === 'farm_ids') {
        const farmIds = Array.isArray(this.dataFilter.farm_ids)
          ? this.dataFilter.farm_ids
          : [];
        const farmIdsSelected = farmIds.map((farmId) => `${farmId}`);
        const selectedFarms = this.farms.filter((item) =>
          farmIdsSelected.includes(`${item.id}`)
        );
        this.farmSelected = selectedFarms.length
          ? selectedFarms.map((farm) => farm.name).join(', ')
          : null;
        this.tableData = [];
        this.flatTableData = [];
        this.activeFarmTables = [];
        this.dataFilter.activity_ids = [];
        this.loadCpaActivities();
      } else if (data.name === 'by_sel') {
        this.dataFilter.activity_ids = [];
        this.cpaActivities = [];
        this.tableData = [];
        this.flatTableData = [];
        this.activeFarmTables = [];
        this.loadCpaActivities();
      } else if (data.name === 'activity_ids') {
        this.tableData = [];
        this.flatTableData = [];
        this.activeFarmTables = [];
      }
    },

    loadCpaActivities() {
      this.showHideLoading(true);
      if (!this.canLoadCpaActivities) {
        this.cpaActivities = [];
        this.showHideLoading();

        return;
      }

      const params = [];
      const farmIds = Array.isArray(this.dataFilter.farm_ids)
        ? this.dataFilter.farm_ids
        : [];

      if (farmIds.length > 0) {
        params.push(`farm_ids=${farmIds.join(',')}`);
      }

      if (this.dataFilter.year_sel) {
        params.push(`year=${this.dataFilter.year_sel}`);
      }

      const query = params.length ? `?${params.join('&')}` : '';

      Axios.getMasters(`works/cpa/activities${query}`)
        .then((response) => {
          const activities = response.data.data || [];

          this.cpaActivities = this.concatAll(
            activities.map((activity) => {
              const id = activity.activity_id || activity.id;
              const code = activity.activity_code || '';
              const name = activity.activity_name || '';
              const unit =
                activity.unit_abbreviation || activity.unit_name || '';

              return {
                ...activity,
                id,
                name: `${code ? `${code} - ` : ''}${name}${
                  unit ? ` - ${unit}` : ''
                }`,
              };
            })
          );

          this.showHideLoading();
        })
        .catch((error) => {
          this.cpaActivities = [];
          this.showMessageErrors(error);
          this.showHideLoading();
        });
    },

    setupTable(weeks = this.weeks) {
      const { Table } = configTable(weeks);
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
    },

    // Funcion para filtrar
    handleFilter() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;

        const requiredFields = [
          { key: 'farm_ids', label: 'farm' },
          { key: 'by_sel', label: 'bySel' },
          { key: 'year_sel', label: 'year' },
          ...(this.dataFilter.by_sel === 'week'
            ? [
                { key: 'init_week', label: 'initWeek' },
                { key: 'end_week', label: 'endWeek' },
              ]
            : []),
        ];

        const missingField = requiredFields.find(
          ({ key }) => !isset(this.dataFilter[key])
        );
        if (missingField) {
          return this.validationInputsRequired(missingField.label);
        }

        this.getData();
      });
    },

    getData() {
      this.showHideLoading(true);

      let payload = {
        ...this.dataFilter,
        route: 'grow/activitycompletion/filter',
      };

      Axios.postMasters(payload)
        .then((response) => {
          const res = response.data.data || {};
          const report = res.report || [];
          this.rawChart = res.chart || null;
          this.weeks = this.getDisplayWeeks(report, res.weeks || []);
          this.tableData = this.normalizeActivityCompletionReport(report);
          this.flatTableData = this.tableData.reduce(
            (rows, farmGroup) => rows.concat(farmGroup.rows),
            []
          );
          this.activeFarmTables = this.tableData.map(
            (farmGroup) => farmGroup.farm_name
          );

          const chartSeries =
            res.charts &&
            res.charts.activity_completion_time &&
            res.charts.activity_completion_time.series.data
              ? res.charts.activity_completion_time.series
              : [];

          this.hasData =
            this.flatTableData.length > 0 || chartSeries.length > 0;

          if (!this.hasData) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.showHideLoading();
            return;
          }

          this.setupTable(this.weeks);

          this.loadChartsFromBackend(res);

          // Search (filtro tabla)
          try {
            this.searchFuse(
              this.tableColumns.map((c) => c.prop).filter((prop) => prop),
              this.flatTableData,
              0.3
            );
          } catch (error) {
            console.log(error);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          const message =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
              ? error.response.data.message
              : error && error.message
              ? error.message
              : 'Ocurrió un error al consultar la información.';

          SweetAlert.warning(message);
        });
    },

    formatPercent(value) {
      const numberValue = Number(value || 0);

      return `${Formatter.formatNumber(numberValue, 2)}%`;
    },

    formatWeekData(data = {}) {
      const completionRate = Number(data.completion_rate || 0);

      return {
        planned_quantity: Number(data.planned_quantity || 0),
        executed_quantity: Number(data.executed_quantity || 0),
        completion_rate: completionRate,
        completion_rate_formatted: this.formatPercent(completionRate),
      };
    },

    getWeekValue(weekData) {
      return weekData.week || weekData.name || '';
    },

    getActivityWeeks(activity) {
      if (Array.isArray(activity.weeks)) return activity.weeks;

      if (activity.weeks && typeof activity.weeks === 'object') {
        return Object.keys(activity.weeks).map((week) => ({
          week,
          ...activity.weeks[week],
        }));
      }

      return [];
    },

    flattenReport(report) {
      if (Array.isArray(report)) {
        return report;
      }

      if (report && typeof report === 'object') {
        return Object.values(report).reduce(
          (rows, farmRows) =>
            rows.concat(Array.isArray(farmRows) ? farmRows : []),
          []
        );
      }

      return [];
    },

    getReportWeeks(report) {
      const weeks = [];

      this.flattenReport(report).forEach((activity) => {
        this.getActivityWeeks(activity).forEach((weekData) => {
          const week = this.getWeekValue(weekData);

          if (week && !weeks.includes(week)) {
            weeks.push(week);
          }
        });
      });

      return weeks;
    },

    getResponseWeeks(weeks) {
      if (Array.isArray(weeks)) {
        return weeks
          .map((week) =>
            typeof week === 'object' ? this.getWeekValue(week) : week
          )
          .filter((week) => week);
      }

      if (weeks && typeof weeks === 'object') {
        return Object.keys(weeks);
      }

      return [];
    },

    getFilterWeeks() {
      const yearWeeks = this.generateWeekList(this.dataFilter.year_sel);

      if (this.dataFilter.by_sel !== 'week') {
        return yearWeeks;
      }

      const initIndex = yearWeeks.indexOf(this.dataFilter.init_week);
      const endIndex = yearWeeks.indexOf(this.dataFilter.end_week);

      if (initIndex === -1 || endIndex === -1) {
        return [];
      }

      return yearWeeks.slice(initIndex, endIndex + 1);
    },

    getDisplayWeeks(report, responseWeeks = []) {
      const backendWeeks = this.getResponseWeeks(responseWeeks);
      const filterWeeks = backendWeeks.length
        ? backendWeeks
        : this.getFilterWeeks();
      const reportWeeks = this.getReportWeeks(report);

      if (!filterWeeks.length) {
        return reportWeeks;
      }

      return filterWeeks.concat(
        reportWeeks.filter((week) => !filterWeeks.includes(week))
      );
    },

    normalizeActivityCompletionRow(activity, farmName = null) {
      const weeks = {};
      const detailedLots = {};
      const activityName =
        activity.activity_name ||
        activity.name ||
        activity.activity ||
        activity.activity_code ||
        '';

      const activityWeeks = this.getActivityWeeks(activity);
      const catchType = (activity.catch_type || '').toString().toLowerCase();
      const rawDetailedLots =
        activity.detailed_lots &&
        typeof activity.detailed_lots === 'object' &&
        !Array.isArray(activity.detailed_lots)
          ? activity.detailed_lots
          : {};
      const lotEntries = Object.entries(rawDetailedLots);
      const lots = lotEntries.length
        ? lotEntries.map(([lot]) => lot)
        : ['Finca'];
      const farm = activity.farm || {};

      activityWeeks.forEach((weekData) => {
        const week = this.getWeekValue(weekData);

        if (week) {
          weeks[week] = this.formatWeekData(weekData);
        }
      });

      if (catchType === 'finca' || lotEntries.length === 0) {
        detailedLots.Finca = { ...weeks };
      } else {
        lotEntries.forEach(([lotName, lotWeeks]) => {
          detailedLots[lotName] = {};

          Object.entries(lotWeeks || {}).forEach(([week, weekData]) => {
            detailedLots[lotName][week] = this.formatWeekData(weekData);
          });
        });
      }

      return {
        activity: activityName,
        farm_id: farm.id || activity.farm_id || farmName,
        farm_name: farm.name || activity.farm_name || farmName || 'Finca',
        lots,
        weeks,
        detailed_lots: detailedLots,
      };
    },

    normalizeActivityCompletionReport(report) {
      const rows = [];

      if (Array.isArray(report)) {
        const farmName = this.farmSelected || 'Finca';
        const farmRows = report.map((activity) =>
          this.normalizeActivityCompletionRow(activity, farmName)
        );

        if (farmRows.length === 0) {
          return rows;
        }

        return [
          {
            farm_id: farmRows[0] ? farmRows[0].farm_id : farmName,
            farm_name: farmRows[0] ? farmRows[0].farm_name : farmName,
            rows: farmRows,
          },
        ];
      }

      if (!report || typeof report !== 'object') {
        return rows;
      }

      Object.entries(report).forEach(([farmName, farmActivities]) => {
        const farmRows = Array.isArray(farmActivities)
          ? farmActivities.map((activity) =>
              this.normalizeActivityCompletionRow(activity, farmName)
            )
          : [];

        if (farmRows.length === 0) {
          return;
        }

        rows.push({
          farm_id: farmRows[0].farm_id || farmName,
          farm_name: farmRows[0].farm_name || farmName,
          rows: farmRows,
        });
      });

      return rows;
    },

    getFormatter(formatter) {
      return typeof formatter === 'function' ? formatter : null;
    },

    getWeekData(week, source, key) {
      if (source && source[week] && source[week][key] !== undefined) {
        return source[week][key];
      }

      return '';
    },

    getCompletionRateClass(week, source) {
      const value = this.getWeekData(week, source, 'completion_rate');

      if (value === '') {
        return 'completion-rate-transparent';
      }

      return Number(value) === 100
        ? 'completion-rate-green'
        : 'completion-rate-red';
    },

    handleCellStyle({ column }) {
      if (!column.property || !column.property.includes('.completion_rate')) {
        return '';
      }

      return '';
    },

    // Funcion que cargar la data del backend para graficarla
    loadChartsFromBackend(res) {
      const timePayload =
        res && res.charts && res.charts.activity_completion_time
          ? res.charts.activity_completion_time
          : {
              Titulo: '',
              STitulo: '',
              yAxis: '',
              xAxis: [],
              series: [],
            };

      const farmPayload =
        res.charts && res.charts.activity_completion_farm
          ? res.charts.activity_completion_farm
          : { series: [] };

      const activityPayload =
        res.charts && res.charts.activity_completion_activity
          ? res.charts.activity_completion_activity
          : { series: [] };

      const supervisorPayload =
        res.charts && res.charts.activity_completion_supervisor
          ? res.charts.activity_completion_supervisor
          : { series: [] };

      const options0 = this.lines(timePayload, true, 'auto', false, false);
      const options1 = this.columns(farmPayload, true);
      const options2 = this.columns(activityPayload, true);
      const options3 = this.columns(supervisorPayload, true);

      this.$set(this.chartOptions, 0, options0);
      this.$set(this.chartOptions, 1, options1);
      this.$set(this.chartOptions, 2, options2);
      this.$set(this.chartOptions, 3, options3);
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();

      Axios.getMasters('farms/farms/only')
        .then((responseFarm) => {
          this.farms = this.concatAll(responseFarm.data.data);

          this.searchQuery = '';

          this.showHideLoading();
          this.loadCpaActivities();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
      this.handleChangeYear(this.dataFilter.year_sel);
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('lossreport');
  },

  destroyed() {
    this.deselectedItemOnMenu('lossreport');
  },
};
</script>
<style lang="scss" scoped>
.legend-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 20px;
  white-space: nowrap;
  margin: 10px 0;
}

.legend-item {
  font-size: 14px;
}

::v-deep .el-table__expanded-cell {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
}

.expand-content {
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
}

.expand-content table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.expand-content td {
  padding: 12px 8px !important;
  margin: 0 !important;
  border: 1px solid gainsboro !important;
  text-align: center;
  vertical-align: middle;
}

/* Asegurar que las filas de la tabla interna no tengan margen extra */
.expand-content tr {
  border: none !important;
  margin: 0px !important;
}

/* Eliminar cualquier borde o separación extra en la tabla expandida */
::v-deep .el-table__expanded-cell[class*='cell'] {
  padding: 0px !important;
  margin: 0px !important;
}

.completion-rate-red {
  background-color: #fde6e4 !important;
}

.completion-rate-green {
  background-color: #e6fdeb !important;
}

.completion-rate-transparent {
  background-color: transparent !important;
  color: inherit !important;
}
</style>
